

































































































































































































































































import { Component, Prop, Vue, Watch, Mixins } from 'vue-property-decorator'
import TaskApi from '@/api/task'
import BillApi from '@/api/bill2'
import { TOKEN, SO_FAR } from '@/store/mutation-types'
import PageLayout from '@/components/page/PageLayout.vue'
import {
	uuid,
	dateFormat,
	throttle,
	download,
	triggerWindowResizeEvent,
} from '@/utils/util'
import moment from 'moment'
import EvaluateApi from '@/api/evaluate'
import Task from '@/web-task'
import cloneDeep from 'lodash/cloneDeep'
import { initOrderDetail } from '@/web-task/utils/order'
import { wsURL } from '@/api/url'
import setting from '@/core/setting'
import InvestigateApi from '@/api/investigate'
import Info from '@/components/task/Info.vue'
import InfoRow from '@/views/AiiTasks/InfoRow.vue'
import { formatTime, formatDate, format } from '@/web-task/filter'
import { zeroUnit } from '@/web-task/utils'
import Bubble from '@/components/Bubble.vue'
import addTaskMixin from './addTaskMixin'
const PIAO_JU_JIE_XI = '13'
const PIAO_JU_CHA_XUN = '6'
const PIAO_JU_YAN_ZHENG = '7'
const payerPartyTypeMap: any = {
	'1': '个人',
	'2': '单位',
}

Component.registerHooks([
	'beforeRouteEnter',
	'beforeRouteUpdate',
	'beforeRouteLeave',
])

@Component({
	name: 'bill2TaskDetail',
	components: {
		PageLayout,
		Info,
		InfoRow,
		Bubble,
	},
})
export default class QueryList extends Mixins(addTaskMixin) {
	private addResurveyVisible: boolean = false
	private taskLog: any = []
	private taskLogVisible: boolean = false
	private order: any = ''
	private injured: any = ''
	private task: any = {}
	private exporting: boolean = false
	private active: any = 0
	private baseInfo: any = {}
	private results: any = []
	private departmentName: any = []
	private PIAO_JU_CHA_XUN = PIAO_JU_CHA_XUN
	private columns1: any = [
		{
			title: '项目名称',
			align: 'center',
			dataIndex: 'itemName',
			width: 150,
		},
		{
			title: '项目编码',
			align: 'center',
			dataIndex: 'itemCode',
			width: 150,
		},
		{
			title: '项目数量',
			align: 'center',
			dataIndex: 'itemQuantity',
			width: 100,
		},
		{
			title: '项目单位',
			align: 'center',
			dataIndex: 'itemUnit',
			width: 100,
		},
		{
			title: '项目标准',
			align: 'center',
			dataIndex: 'itemStd',
			width: 150,
		},
		{
			title: '项目金额',
			align: 'center',
			dataIndex: 'itemAmount',
			width: 150,
		},
		{
			title: '项目备注',
			align: 'center',
			dataIndex: 'itemRemark',
			width: 150,
		},
	]
	private columns2: any = [
		{
			title: '明细编码',
			align: 'center',
			dataIndex: 'auxItemCode',
			width: 150,
		},
		{
			title: '明细名称',
			align: 'center',
			dataIndex: 'auxItemName',
			width: 150,
		},
		{
			title: '明细数量',
			align: 'center',
			dataIndex: 'auxItemQuantity',
			width: 100,
		},
		{
			title: '明细单位',
			align: 'center',
			dataIndex: 'auxItemUnit',
			width: 100,
		},
		{
			title: '明细标准',
			align: 'center',
			dataIndex: 'auxItemStd',
			width: 150,
		},
		{
			title: '明细金额',
			align: 'center',
			dataIndex: 'auxItemAmount',
			width: 150,
		},
		{
			title: '明细备注',
			align: 'center',
			dataIndex: 'auxItemRemark',
			width: 150,
		},
	]
	private columns3: any = [
		{
			title: '序号',
			align: 'center',
			dataIndex: 'key',
		},
		{
			title: '就诊日期',
			align: 'center',
			dataIndex: 'medicalDate',
		},
		{
			title: '就诊机构',
			align: 'center',
			dataIndex: 'medicalOrgName',
		},
		// {
		// 	title: '科室开通情况',
		// 	align: 'center',
		// 	dataIndex: 'deptInfo',
		// },
		{
			title: '操作',
			align: 'center',
			scopedSlots: { customRender: 'operation' },
		},
	]
	private queryInfo: any = {}
	private authInfo: any = {}
	private medicalTypeMap: any = {
		'01': '住院',
		'02': '门诊',
		'03': '急诊',
		'04': '门特',
		'05': '体检中心',
		'06': '挂号',
	}

	private init() {
		this.baseInfo = {}
		this.results = []
		this.getDetail()
	}

	private activated() {
		this.init()
	}

	private beforeRouteUpdate(to: any, from: any, next: any) {
		this.$nextTick(() => {
			this.init()
		})
		next()
	}

	private get isMedicalRecord() {
		// 就诊记录
		return this.$route.params.taskType === '14'
	}

	private get medicalRecord() {
		return (this.results || []).map((item: any, index: number) => {
			return Object.assign({}, item, { key: index + 1 })
		})
	}

	private get isSuccess() {
		return this.baseInfo.orderStatus === '10'
	}

	private get isFail() {
		return this.baseInfo.orderStatus === '11'
	}

	private get tableData() {
		const info = (this.results[this.active] || {}).itemDetail
		if (!info) {
			return []
		}
		const arr: any = cloneDeep(info)
		for (const item of arr) {
			if (item.itemAmount) {
				item.itemAmount = zeroUnit(item.itemAmount, '元')
			}
			for (const aux of item.auxDetail) {
				if (aux.auxItemAmount) {
					aux.auxItemAmount = zeroUnit(aux.auxItemAmount, '元')
				}
			}
		}
		return arr
	}

	private zeroUnit(val: string, unit: string) {
		return zeroUnit(val, unit)
	}

	private getAccountList(item: any) {
		return [
			{ label: '入账日期', value: item.accDate },
			{ label: '入账金额', value: zeroUnit(item.accAmount, '元') },
		]
	}

	private get invoice() {
		const invoice = this.results[this.active] || {}
		return invoice
	}

	private get billInfo() {
		const info = (this.results[this.active] || {}).invoiceMainInfo
		if (!info) {
			return []
		}
		let arr = [
			{ label: '电子票据名称', value: info.invoiceName },
			{ label: '电子票据代码', value: info.invoiceCode },
			{ label: '电子票据号码', value: info.invoiceNumber },
			{ label: '校验码', value: info.invoiceCheckCode },
			{
				label: '开票时间',
				value: `${info.issueDate} ${info.issueTime}`,
			},
			{
				label: '总金额',
				value: zeroUnit(info.totalAmount, '元'),
				slot: 'totalAmount',
			},
			{ label: '开票单位代码', value: info.invoicingPartyCode },
			{ label: '开票单位名称', value: info.invoicingPartyName },
			{ label: '交款人类型', value: payerPartyTypeMap[info.payerPartyType] },
			{ label: '交款人名称', value: info.payerPartyName },
			{ label: '交款人代码', value: info.payerPartyCode },
			{ label: '交款方式', value: info.payMode },
			{ label: '业务流水号', value: info.bizCode },
			{ label: '开票人', value: info.handlingPerson },
			{ label: '复核人', value: info.checker },
		]
		for (const item of arr) {
			if (!item.value) {
				item.value = '-- / --'
			}
		}
		return arr
	}

	private get hasRelated() {
		return !!this.billInfo2.find((item: any) => {
			return item.label === '相关票据代码'
		})
	}

	private get billInfo2() {
		const info = (this.results[this.active] || {}).mainExtInfo
		if (!info) {
			return []
		}
		let arr: any = [
			{ label: '业务单号', value: info.businessNumber },
			{ label: '业务日期', value: info.businessDate },
			{ label: '性别', value: info.gender },
			{ label: '年龄', value: info.age },
			{ label: '医疗类型', value: this.medicalTypeMap[info.medicalType] },
			{ label: '门诊号', value: info.patientNumber },
			{ label: '就诊日期', value: info.medicalDate },
			{ label: '医疗机构类型', value: info.orgType },
			{ label: '医保类型', value: info.medicalInsuranceType },
			{ label: '医保编号', value: info.medicalInsuranceId },
			{ label: '医保统筹基金支付', value: zeroUnit(info.fundPayAmount, '元') },
			{ label: '其他支付', value: zeroUnit(info.otherPayAmount, '元') },
			{ label: '个人账户支付', value: zeroUnit(info.accountPayAmount, '元') },
			{ label: '个人现金支付', value: zeroUnit(info.ownPayAmount, '元') },
			{ label: '个人自付', value: zeroUnit(info.selfPaymentAmount, '元') },
			{ label: '个人自费', value: zeroUnit(info.selfPaymentCost, '元') },
			{ label: '病例号', value: info.caseNumber },
			{ label: '住院号', value: info.hospitalizationNumber },
			{ label: '科别', value: info.departmentName },
			{ label: '住院日期', value: info.inHospitalDate },
			{ label: '出院日期', value: info.outHospitalDate },
		]
		if (info.relatedInvoiceCode) {
			arr.push({
				label: '相关票据代码',
				value: info.relatedInvoiceCode,
				slot: 'invoiceCode',
			})
		}
		if (info.relatedInvoiceNumber) {
			arr.push({ label: '相关票据号码', value: info.relatedInvoiceNumber })
		}
		for (const item of arr) {
			if (!item.value) {
				item.value = '-- / --'
			}
		}
		return arr
	}

	private addSettle(row: any) {
		let newSettle = {
			patientName: this.baseInfo.patientName,
			idCard: this.baseInfo.idCard,
			telPhone: this.baseInfo.telPhone,
			medicalOrgName: row.medicalOrgName,
			authorizeInfoId: this.baseInfo.authorizeInfoId,
			authorizeInfoName: this.baseInfo.authorizeInfoName,
			relateRecordId: row.id,
			parentOrderId: this.$route.params.orderId,
		}
		this.submitting = true
		BillApi.addBill(newSettle).then((res: any) => {
			this.pollingAdd({ orderId: res.data }, () => {
				this.getDetail()
			})
		})
	}

	private researchSettle(orderId: string) {
		this.bill2Research({ orderId }, () => {
			this.init()
		})
	}

	private exportOrder() {
		this.exporting = true
		BillApi.exportOrder(this.$route.params.orderId)
			.then((res: any) => {
				const blob: any = new Blob([res.data])
				download(blob, res.filename)
			})
			.finally(() => {
				this.exporting = false
			})
	}

	private getDetail() {
		let detailPromise: any
		if (this.isMedicalRecord) {
			// 就诊记录详情
			detailPromise = BillApi.getMedicalRecordDetail(this.$route.params.orderId)
		} else {
			detailPromise = BillApi.getDetail(this.$route.params.orderId)
		}
		return detailPromise.then((res: any) => {
			const baseInfo = res.data.baseInfo
			this.baseInfo = res.data.baseInfo
			this.results = res.data.results
			this.departmentName = res.data.departmentName
			this.active = 0
			let arr: any = [
				{ label: '查询公司', value: baseInfo.companyName },
				{ label: '订单号', value: baseInfo.orderNo },
				{ label: '查询时间', value: formatTime(baseInfo.searchTime) },
				{ label: '查询人', value: baseInfo.creatorName },
			]
			if (baseInfo.taskType !== PIAO_JU_JIE_XI) {
				// 票据查询/票据验证
				arr = arr.concat([
					{ label: '就诊人姓名', value: baseInfo.patientName },
					{ label: '就诊人电话', value: baseInfo.telPhone },
					{ label: '就诊人身份证号', value: baseInfo.idCard },
				])
				if (baseInfo.taskType === PIAO_JU_CHA_XUN) {
					arr.push(
						{ label: '查询就诊机构', value: baseInfo.medicalOrgName },
						{
							label: '查询开始时间',
							value: formatDate(baseInfo.startIssueDate),
						},
						{ label: '查询结束时间', value: formatDate(baseInfo.endIssueDate) }
					)
				} else if (baseInfo.taskType === PIAO_JU_YAN_ZHENG) {
					arr.push(
						{ label: '票据代码', value: baseInfo.invoiceCode },
						{ label: '票据号码', value: baseInfo.invoiceNumber },
						{ label: '校验号码', value: baseInfo.invoiceCheckCode },
						{ label: '开票日期', value: baseInfo.issueDate },
						{
							label: '总金额',
							value: baseInfo.totalAmount,
							slot: 'totalAmount',
						}
					)
				}
			}
			arr.push(
				{
					label: '查询类型',
					value: this.$store.state.setting.einvoiceTasktypeMap[
						baseInfo.taskType
					],
				},
				{
					label: '查询状态',
					value: this.$store.state.setting.invoiceTaskStatusMap[
						baseInfo.orderStatus
					],
				}
			)
			if (baseInfo.taskType === PIAO_JU_JIE_XI) {
				arr.push({
					label: '影像文件',
					value: baseInfo.invoiceFileUrl,
					slot: 'url',
				})
			} else {
				arr.push({
					label: '授权文件',
					value: baseInfo.authorizeInfoUrl,
					slot: 'url',
				})
			}
			const queryInfo = {
				title: '查询信息',
				children: arr,
			}
			for (const item of queryInfo.children) {
				if (!item.value) {
					item.value = '-- / --'
				}
			}
			this.queryInfo = queryInfo
		})
	}
}
